import { Icons } from '@atoms';
import { Col, Row } from 'antd';
import styled from 'styled-components';

export const TextLogin = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: center;
  color: #fff;
`;

export const Container = styled(Row)`
  height: 100vh;
  background: linear-gradient(135deg, #141414 0%, #232323 100%);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      radial-gradient(
        circle at 20% 80%,
        rgba(255, 255, 255, 0.08) 0%,
        rgba(20, 20, 20, 0.92) 50%,
        transparent 85%
      ),
      radial-gradient(
        circle at 80% 20%,
        rgba(255, 255, 255, 0.06) 0%,
        rgba(20, 20, 20, 1) 50%,
        transparent 85%
      ),
      radial-gradient(
        circle at 40% 40%,
        rgba(255, 255, 255, 0.05) 0%,
        rgba(20, 20, 20, 0.85) 50%,
        transparent 85%
      );
    pointer-events: none;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const BrandLogo = styled(Icons.Logo)`
  padding: 20px;
  filter: brightness(0) invert(1);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const RightCol = styled(Col)`
  margin: auto;
  z-index: 1;
  position: relative;
  max-width: 450px;
`;

export const Header = styled.div`
  margin-bottom: 32px;
  text-align: center;
`;

export const FormContainer = styled.div`
  width: 100%;
  background: #141414;
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  padding: 32px 20px;
  border-radius: 12px;
  max-width: 450px;
  animation: slideUp 0.6s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Estilos para os inputs do formulário */
  .ant-input,
  .ant-input-password {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #fff;
    border-radius: 8px;
    height: 32px;

    &::placeholder {
      color: rgba(255, 255, 255, 0.6);
    }

    &:focus,
    &.ant-input-focused {
      border-color: #40a9ff;
      box-shadow: 0 0 0 2px rgba(64, 169, 255, 0.2);
    }
  }

  .ant-input-password-icon {
    color: rgba(255, 255, 255, 0.6);

    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  /* Estilo para o botão */
  .ant-btn-primary {
    border: none;
    height: 42px;
    border-radius: 8px;
    font-weight: 600;

    transition: all 0.3s ease;

    &:hover {
      background: linear-gradient(135deg, #69c0ff 0%, #40a9ff 100%);
    }
  }

  /* Labels dos formulários */
  .ant-form-item-label > label {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 500;
  }

  /* Links */
  a {
    color: #40a9ff;

    &:hover {
      color: #69c0ff;
    }
  }
`;

export const GlassEffect = styled.div`
  position: absolute;
  top: -20px;
  left: -20px;
  right: -20px;
  bottom: -20px;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 100%
  );
  backdrop-filter: blur(400px);
  border-radius: 20px;
  z-index: -1;
`;
